<template>
  <div class="activityCompletion flexcenter">
    <transition>
      <div class="activity flexcenter">
        <div class="activityTitle">
          <h3>アクティビティ完了</h3>
          <div class="font14">レッスン{{ lessonIndex + 1 }} : 【{{ pathTitle }}】が完了しました。</div>
        </div>
        <div class="activityContent">
          <div class="activityScore flexcenter">
            <div class="item align-center">
              <div>正解率</div>
              <div class="answerRate textorange"><span class="font60">{{ answerRate }}</span><span class="font30">%</span></div>
            </div>
            <div class="item">
              <ul class="score-list">
                <li class="flexbetween"><span class="ok align-left">正解</span><span class="align-right">{{ ok }}</span></li>
                <li class="flexbetween"><span class="ng align-left">不正解</span><span class="align-right">{{ ng }}</span></li>
                <li class="flexbetween"><span class="skip align-left">スキップ</span><span class="align-right">{{ skip }}</span></li>
                <li class="total font14"><span>合計</span><span class="align-right">{{ count }} / {{ total }}</span></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="activityFooter">
          <div class="font14">次のアクティビティ : ユニット{{ nextUnitNo }} 「{{ nextUnitTitle }}」 レッスン{{ nextLessonIndex + 1 }} : 【{{ nextPathTitle }}】</div>
          <div class="buttons flexbetween">
            <button type=button v-on:click="clickButton('home')" class="home">ホーム</button>
            <button type=button v-on:click="clickButton('repeat')" class="retry">繰り返す</button>
            <button type=button v-on:click="clickButton('continue')" class="continue">続行</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import common from '@/mixin/common'

export default {
  name: 'activityCompletion',
  props: {
    lessonIndex: Number,
    pathTitle: String,
    answerRate: Number,
    ok: Number,
    ng: Number,
    skip: Number,
    total: Number,
    nextUnitNo: Number,
    nextUnitTitle: String,
    nextLessonIndex: Number,
    nextPathTitle: String
  },
  data () {
    return {
      count: 0
    }
  },
  mixins: [
    common,
  ],
  methods: {
    clickButton: function(kind) {
      this.log("ActivityCompletion clickButton kind: " + kind)
      this.$emit('clickButton', kind)
    }
  },
  created: function() {
    this.log("ActivityCompletion start created")
    this.count = this.ok + this.ng + this.skip
  },
  mounted: function() {
    this.log("ActivityCompletion start mounted")
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// ActivityCompletion.vue?f1f51ba4